import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { DataValidator } from 'app/tools/custom-formgroup-validator';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { LoginComponent } from 'app/view/auth/login/login.component';
import { Console } from 'console';

@Component({
  selector: 'text-data-fabricacao',
  templateUrl: './text-data-fabricacao.component.html',
  styleUrls: ['./text-data-fabricacao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextDataFabricacaoComponent implements OnInit {

  formGroup: FormGroup;
  now: string = new Date().toISOString().split('T')[0];

  get setValue(): string {
    if (!this.formGroup.get("equipamento").get("dtInicial").value) return "";
    const dateObject = new Date(this.formGroup.get("equipamento").get("dtInicial").value);
    return dateObject.toISOString().split('T')[0];
  }
  
  constructor(
    private _controlContainer: ControlContainer
  ) { }
  
  ngOnInit() { 
    this.formGroup = this._controlContainer.control as FormGroup;
    this._validators();
  }
  
  async ngAfterViewInit() {
  }
  
  private _validators() {
    const date = new Date();
    date.setHours(23, 59, 59, 59);
    this.formGroup.get('dtInicial').setValidators([DataValidator.max(date)]);
    this.formGroup.get('dtInicial').updateValueAndValidity();
  }
}
